'use client';

import { useLanguage } from '@/contexts/LanguageContext';

interface IntroStatementProps {
  title: string;
  description: string;
  highlightText: string;
}

const IntroStatement = ({ title, description, highlightText }: IntroStatementProps) => {
  const { t } = useLanguage();
  
  return (
    <section className="bg-card rounded-lg p-8 md:p-12 shadow-elevation-md relative overflow-hidden">
      <div className="relative z-10">
        <h1 className="font-heading text-3xl md:text-4xl font-semibold text-primary mb-6">
          {title}
        </h1>
        <p className="font-body text-base md:text-lg text-foreground leading-relaxed mb-6">
          {description}
        </p>
        <div className="bg-accent/10 border-l-4 border-accent p-6 rounded-md">
          <p className="font-body text-base md:text-lg text-foreground italic">
            &quot;{highlightText}&quot;
          </p>
        </div>
        
        {/* Investment Example Box */}
        <div className="mt-6 bg-primary/5 border-2 border-primary/20 rounded-lg p-6 md:p-8">
          <div className="flex items-start justify-between mb-4">
            <h3 className="font-heading text-xl md:text-2xl font-semibold text-primary">
              {t('whyGoldSilver.example.title')}
            </h3>
            <span className="text-xs font-semibold text-accent bg-accent/10 px-3 py-1 rounded-full">
              {t('whyGoldSilver.example.trendRising')}
            </span>
          </div>
          <div className="space-y-3">
            <p className="font-body text-base md:text-lg text-foreground font-medium">
              {t('whyGoldSilver.example.investmentTitle')}
            </p>
            <p className="font-body text-base text-foreground">
              {t('whyGoldSilver.example.investmentPeriod')}
            </p>
            <p className="font-body text-base text-foreground font-semibold text-primary mt-4">
              {t('whyGoldSilver.example.goldAmount')}
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6 pt-6 border-t border-primary/20">
              <div>
                <p className="font-body text-sm text-foreground/70 mb-1">{t('whyGoldSilver.example.totalInvestment')}</p>
                <p className="font-heading text-2xl font-bold text-foreground">{t('whyGoldSilver.example.totalInvestmentValue')}</p>
              </div>
              <div>
                <p className="font-body text-sm text-foreground/70 mb-1">{t('whyGoldSilver.example.currentValue')}</p>
                <p className="font-heading text-2xl font-bold text-accent">{t('whyGoldSilver.example.currentValueAmount')}</p>
              </div>
            </div>
            <p className="text-xs text-foreground/60 mt-4 pt-4 border-t border-primary/10">
              {t('whyGoldSilver.example.asOf')}
            </p>
          </div>
        </div>
      </div>
    </section>);

};

export default IntroStatement;